/**
 * Fait : accroche l'application React à la page, et charge les styles de base.
 *   L'atelier est la vue par défaut ; la page de socle de la phase 1 reste
 *   atteignable par `#/socle`, parce que les vérifications des cinq états
 *   s'appuient sur elle et qu'un banc d'essai ne se jette pas.
 *
 * Ne fait pas : il ne contient aucune vue ni aucune logique — tout ce qui
 *   s'affiche vit dans un composant.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Atelier } from './atelier/Atelier.tsx';
import { PageSocle } from './PageSocle.tsx';
import './styles/polices.css';
/*
 * Les six morceaux de l'ancien base.css, DANS L'ORDRE DU FICHIER D'ORIGINE :
 * la cascade CSS dépend de cet ordre, et la preuve du découpage (phase 3 de
 * la refonte visuelle) compare leur concaténation à l'ancien fichier. On ne
 * réordonne pas ces lignes.
 */
import './styles/socle.css';
import './styles/fil.css';
import './styles/gabarit.css';
import './styles/casiers.css';
import './styles/notice.css';
import './styles/formulaires.css';

const racine = document.getElementById('racine');

if (racine === null) {
  throw new Error('Élément racine introuvable : la page ne peut pas être montée.');
}

const surLeSocle = location.hash.startsWith('#/socle');

createRoot(racine).render(<StrictMode>{surLeSocle ? <PageSocle /> : <Atelier />}</StrictMode>);
